import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/')({
  beforeLoad: async ({ params: { org, loopId }, context: { flags } }) => {
    throw redirect({
      to: flags.loopNewUi ? '/org/$org/loop/$loopId/overview' : '/org/$org/loop/$loopId/insights',
      params: { org, loopId },
      replace: true,
    });
  },
});
